<template>
    <Select :modelValue="modelValue" :options="options" optionLabel="label" optionValue="value"
        :placeholder="placeholder || 'Select Programme'" :class="className" filter showClear
        @update:modelValue="onUpdate" @change="onChange" :loading="loading" />
</template>

<script setup lang="ts">
import { useProgrammes } from '@/composables/queries/useProgrammes';

const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
  className: {
    type: String,
    default: 'w-full',
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const { programmes, loadingSchoolProgramme: loading } = useProgrammes({ autoFetch: true, first: 200 });

const options = computed(() => programmes.value?.map((p) => ({
  label: p.program_name + (p.prog_code ? ` (${p.prog_code})` : ''),
  value: p.id,
})) || []);

const onUpdate = (value: string | number | null) => {
  emit('update:modelValue', value);
};

const onChange = (event: unknown) => {
  emit('change', event);
};
</script>
